module.exports = __webpack_public_path__ + "img/1.bd7507f6.jpg";